import { useEffect, useRef, useState } from 'react';

import { getApiErrorMessage } from '../../../helpers/utils/ui';
import {
  crmAnalyticsApi,
  TCrmCohorts,
  TCrmPeriod,
  TCrmSchools,
  TCrmSummary,
} from '../../../shared/common/api/endpoints/crmAnalyticsApi';

// Сводка и когорты зависят от периода (period мемоизирован на странице),
// список школ — за всё время и грузится один раз
export const useCrmAnalytics = (period: TCrmPeriod) => {
  const [ summary, setSummary ] = useState<TCrmSummary | null>(null);
  const [ cohorts, setCohorts ] = useState<TCrmCohorts | null>(null);
  const [ schools, setSchools ] = useState<TCrmSchools | null>(null);
  const [ periodLoading, setPeriodLoading ] = useState(false);
  const [ schoolsLoading, setSchoolsLoading ] = useState(false);
  const [ periodError, setPeriodError ] = useState<string | null>(null);
  const [ schoolsError, setSchoolsError ] = useState<string | null>(null);

  // Номер запроса: ответ за прошлый период, пришедший позже, отбрасывается
  const requestSeqRef = useRef(0);

  useEffect(() => {
    const seq = ++requestSeqRef.current;
    setPeriodLoading(true);
    setPeriodError(null);

    Promise.all([ crmAnalyticsApi.getSummary(period), crmAnalyticsApi.getCohorts(period) ])
      .then(([ summaryResponse, cohortsResponse ]) => {
        if (seq !== requestSeqRef.current) return;
        setSummary(summaryResponse.data);
        setCohorts(cohortsResponse.data);
      })
      .catch((err) => {
        if (seq !== requestSeqRef.current) return;
        setPeriodError(getApiErrorMessage(err, 'Не удалось загрузить аналитику за период'));
      })
      .finally(() => {
        if (seq === requestSeqRef.current) setPeriodLoading(false);
      });
  }, [ period ]);

  useEffect(() => {
    setSchoolsLoading(true);

    crmAnalyticsApi.getSchools()
      .then((response) => setSchools(response.data))
      .catch((err) => setSchoolsError(getApiErrorMessage(err, 'Не удалось загрузить список школ')))
      .finally(() => setSchoolsLoading(false));
  }, []);

  return {
    summary,
    cohorts,
    schools,
    periodLoading,
    schoolsLoading,
    periodError,
    schoolsError,
  };
};
